import React from 'react';
import { IndexPage } from '../../routes/IndexPage';

export const REGISTRATION = {
    QUERY: '?action=registration',
    TITLE: 'Your Powerboard Account is Pending',
    INFO: 'Please check your email for instructions on how to complete the registration process.',
};
export const PASSWORD = {
    QUERY: '?action=set-password',
    TITLE: 'Your Password Has Been Set',
    LINK: 'Please click here to log in to Powerboard.',
};

export const RegistrationHandler = ({ location, children }) => {
    switch (location.search) {
        case REGISTRATION.QUERY:
            return <IndexPage title={REGISTRATION.TITLE} info={REGISTRATION.INFO} />;
        case PASSWORD.QUERY:
            return <IndexPage title={PASSWORD.TITLE} link={PASSWORD.LINK} />;
        default:
            return children;
    }
};
